import ErrorHandler from '../helpers/ErrorHandler';
import RegistrationService from '../services/RegistrationService';
import MerchantConstants from '../constants/MerchantConstants';
import {hashHistory} from 'react-router';
import ErrorsConstants from "../constants/ErrorsConstants";
import store from 'store';
import {NotificationManager} from "react-notifications";

export default {
  sendData: (data) => dispatch => {
    dispatch({type: 'ON_BUSY'});
    RegistrationService.sendData(data).then(() => {
      dispatch({type: 'OFF_BUSY'});
      hashHistory.push('/sign/check_email');
    }, (err) => {
      if (err.status === 422 && err.response !== '') {
        let response = JSON.parse(err.response);
        if (response.errors[0] = 'Email has already been taken') {
          dispatch({type: ErrorsConstants.INCORRECT_ENTITIES, payload: 'Email has already been taken'});
        }
      } else {
        ErrorHandler(err)
      }
      dispatch({type: 'OFF_BUSY'});
    })
  },
  verifyEmailToken: (token) => dispatch => {
    dispatch({type: 'ON_BUSY'});
    RegistrationService.verifyEmail(token).then(() => {
      dispatch({type: 'OFF_BUSY'});
      dispatch({type: 'SET_EMAIL_TOKEN', payload: token});
      hashHistory.push('/sign/owner');
    }, (err) => {
      dispatch({type: 'OFF_BUSY'});
      if (err.status === 401) {
        hashHistory.push('/sign/error_expired');
      } else {
        ErrorHandler(err)
      }
    })
  },
  sendOwnerData: (data) => dispatch => {
    dispatch({type: 'ON_BUSY'});
    RegistrationService.sendOwnerData(data).then((response) => {
      dispatch({type:'SET_DATA_OWNER',
      payload: {
        phone: response.merchant.display_phone,
        token: response.merchant.authentication_token
      }});
      store.set('regDataRf1', {
        phone: response.merchant.display_phone,
        token: response.merchant.authentication_token
      });
      hashHistory.push('/sign/verify');
      dispatch({type: 'OFF_BUSY'});
    }, (err) => {
      dispatch({type: 'OFF_BUSY'});
      ErrorHandler(err)
    })
  },
  sendCall: (extension, token) => dispatch => {
    dispatch({type: 'ON_BUSY'});
    RegistrationService.sendCall(extension, token).then(() => {
      hashHistory.push('/signup/check_code');
      dispatch({type: 'OFF_BUSY'});
    }, () => {
      dispatch({type: 'OFF_BUSY'});
      hashHistory.push('/sign/error');
    })
  },
  sendCode: (token) => dispatch => {
    dispatch({type: 'ON_BUSY'});
    RegistrationService.sendCode(token).then(() => {
      hashHistory.push('/signup/check_code');
      dispatch({type: 'OFF_BUSY'});
    }, () => {
      dispatch({type: 'OFF_BUSY'});
      hashHistory.push('/sign/error');
    })
  },
  checkCode: (code, token) => dispatch => {
    dispatch({type: 'ON_BUSY'});
    RegistrationService.checkCode(code, token).then(() => {
      store.remove('regDataRf1');
      hashHistory.push('/sign/finish');
      dispatch({type: 'OFF_BUSY'});
    }, (error) => {
      dispatch({type: 'OFF_BUSY'});
      let err = {};
      if (error.response !== '') {
        err = JSON.parse(error.response);
      }
      switch (error.status) {
        case 400:
          NotificationManager.warning(err.errors[0]);
          break;
        case 500:
          hashHistory.push('/sign/error');
          break;
        default:
          ErrorHandler(error);
          break;
      }
    })
  },
  getMerchantTypes: () => dispatch => {
    dispatch({type: 'ON_BUSY'});
    RegistrationService.getTypes().then((response) => {
      dispatch({
        type: MerchantConstants.MERCHANT_GET_TYPES,
        payload: response.signup
      });
      dispatch({type: 'OFF_BUSY'});
    }, (err) => {
      dispatch({type: 'OFF_BUSY'});
      ErrorHandler(err)
    });
  },
}


/** WEBPACK FOOTER **
 ** ./src/actions/RegistrationAction.js
 **/